import { Col, Form, Input, Modal, Row } from 'antd';
import React, { useState } from 'react';
import { createCustomer } from 'api/customers';
import FormItem from 'components/FormItem';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import { getHttpErrorMessage } from 'utils/http';
import { App } from 'antd';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function AddCustomerModal({ open, onClose, onSuccess }) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const { message } = App.useApp();

  const handleOk = () => {
    form.validateFields().then((values) => {
      setSaving(true);
      const payload = {
        phone: values.phone ? `+${values.phone}` : '',
        name: values.name?.trim() || '',
        email: values.email?.trim() || '',
      };
      createCustomer(payload)
        .then((res) => {
          const data = getData(res)?.data ?? getData(res) ?? res?.data ?? res;
          onSuccess?.(data);
          message.success('Customer created');
          form.resetFields();
          onClose();
        })
        .catch((e) => {
          captureException(e);
          message.error(getHttpErrorMessage(e));
        })
        .finally(() => setSaving(false));
      return null;
    }).catch(() => {});
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Add Customer"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={saving}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <FormItem name="phone" label="Phone number" fullWidth rules={[{ required: true, message: 'Phone is required' }]}>
              <PhoneInput
                country="us"
                buttonClass="phone-country"
                inputClass="input"
                inputProps={{ name: 'phone', required: true }}
                inputStyle={{ width: '100%' }}
                placeholder="Enter phone number"
                preferredCountries={['us', 'ca']}
                enableSearch
                regions={['america', 'europe']}
                countryCodeEditable={false}
              />
            </FormItem>
          </Col>
          <Col xs={24} lg={12}>
            <FormItem name="name" label="Name" fullWidth rules={[{ required: true, message: 'Name is required' }]}>
              <Input placeholder="Enter customer name" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem name="email" label="Email" fullWidth rules={[{ required: true, type: 'email', message: 'Valid email is required' }]}>
              <Input placeholder="Enter customer email" type="email" />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddCustomerModal;
